/* Extracted from sections/custom-header.liquid on 2026-08-15.
   Was inline in every document that renders this file; now fetched once and
   cached. Deferred, so it runs after the DOM is parsed rather than at its old
   position — safer for the DOM queries inside, not riskier.
   No Liquid in here, which is why it could move at all. */

document.addEventListener('DOMContentLoaded', function () {
    if (window.innerWidth >= 900) {
      /* Mega menus open via CSS :hover/:focus-within; JS only keeps
         aria-expanded in sync and lets Escape dismiss the panel. */
      var megaItems = document.querySelectorAll('.ch__dropdown--mega');
      megaItems.forEach(function (item) {
        var trigger = item.querySelector('.ch__nav-link--mega');
        function setExpanded(state) {
          if (trigger) trigger.setAttribute('aria-expanded', state ? 'true' : 'false');
        }
        item.addEventListener('mouseenter', function () { setExpanded(true); });
        item.addEventListener('mouseleave', function () { setExpanded(false); });
        item.addEventListener('focusin', function () {
          if (!item.classList.contains('ch__dropdown--dismissed')) setExpanded(true);
        });
        item.addEventListener('focusout', function (e) {
          if (!item.contains(e.relatedTarget)) {
            item.classList.remove('ch__dropdown--dismissed');
            setExpanded(false);
          }
        });
        item.addEventListener('keydown', function (e) {
          if (e.key === 'Escape') {
            item.classList.add('ch__dropdown--dismissed');
            setExpanded(false);
            if (trigger) trigger.focus();
          }
        });
      });

      /* Standard dropdowns only — mega menus use pure CSS :hover */
      var navItems = document.querySelectorAll('.ch__dropdown:not(.ch__dropdown--mega)');
      navItems.forEach(function (item) {
        item.addEventListener('mouseenter', function () {
          item.setAttribute('open', '');
        });
        item.addEventListener('mouseleave', function () {
          item.removeAttribute('open');
        });
        var summary = item.querySelector('summary');
        if (summary) {
          summary.addEventListener('click', function (e) {
            if (item.querySelector('.ch__submenu')) e.preventDefault();
          });
        }
      });
    }
  });

/* ── Reveal-on-scroll-up navigation ─────────────────────────────────────────
   The header was written to stick and never did. Shopify wraps each section in
   a div exactly as tall as the header inside it, so `position: sticky` on .ch
   had no room to travel: measured on the live site 2026-09-01, the header sat
   at -2049px at scroll 2500 on the homepage and stayed there when scrolling
   back up. Every page, desktop and mobile. Several `scroll-margin-top: 80px`
   rules elsewhere in the theme were already written for a sticky header that
   was not there; they become correct once this works.

   Sticky has to be applied to the section GROUP, whose parent is <body>. This
   adds the class that carries it, and drives the hide/reveal state:

     scrolling down   → the navigation slides up out of the way
     scrolling up     → it comes straight back
     cursor near top  → it comes back without scrolling (desktop pointers only)
     keyboard focus   → it comes back, so tabbing never lands on a hidden link
     near page top    → natural position, nothing pinned

   Only the navigation row follows the shopper. The announcement bar and the
   utility strip scroll away and stay away; pinning all three would hold a
   quarter of a laptop screen permanently. */
(function () {
  'use strict';

  var shell = document.getElementById('header-group');
  if (!shell) return;

  var header = shell.querySelector('.ch');
  if (!header) return;

  shell.classList.add('ch-shell');

  var above = 0;

  /* Height of everything above the navigation row. Each strip is its own
     section, so this walks the group's children and stops at the one holding
     the header. */
  function measure() {
    var total = 0;
    var children = shell.children;
    for (var i = 0; i < children.length; i++) {
      if (children[i].contains(header)) break;
      total += children[i].offsetHeight;
    }
    above = total;
    shell.style.setProperty('--ch-above', total + 'px');
  }

  var lastY = window.scrollY;
  var isHidden = false;

  function show() {
    if (!isHidden) return;
    isHidden = false;
    shell.removeAttribute('data-ch-nav');
  }

  function hide() {
    if (isHidden) return;

    /* Never hide something the shopper is using. Focus inside the shell means
       they are in the search field or tabbing the menu; an open dialog or
       dropdown means a panel is hanging off the header. This also keeps the
       mobile search overlay safe — it is position:fixed inside the shell, and
       a transform on an ancestor would re-anchor it to the header. */
    if (shell.contains(document.activeElement)) return;
    if (shell.querySelector('dialog[open], details[open]')) return;

    isHidden = true;
    shell.setAttribute('data-ch-nav', 'hidden');
  }

  var queued = false;

  function onScroll() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      var y = window.scrollY;

      /* Near the top the header is in its natural place — nothing to reveal,
         and hiding here would fight the page's own layout. */
      if (y <= above + 80) {
        lastY = y;
        show();
        return;
      }

      /* A few pixels of slack, so a trackpad wobble or the rubber-band bounce
         at the end of a page does not flip the state back and forth. */
      if (y > lastY + 4) hide();
      else if (y < lastY - 4) show();

      lastY = y;
    });
  }

  /* "Move the cursor to the top and the menu comes back." A generous band, so
     it triggers before the pointer leaves the window entirely. Desktop only:
     a touch screen has no hovering pointer, and there scrolling up does it. */
  function onPointerMove(event) {
    if (event.clientY <= 64) show();
  }

  measure();

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () {
    measure();
    onScroll();
  });
  shell.addEventListener('focusin', show);

  if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    document.addEventListener('mousemove', onPointerMove, { passive: true });
  }
})();
